import {  validateMaxLength, validateRequired , validateNotDigitSpicalCharacters,validateSpicalCharacters , validateLength, validateSpicalCharactersExceptSlash} from "../helpers/Validation";
const validateProfile = (setError, user) => {
    let valid = true;
    //valid user First Name
    if (!validateRequired(user.first_name)) {
        valid = false;
        setError('first_name', 'رجاء إدخال البيانات');
    } else {
        if (!validateMaxLength(user.first_name, 255)) {
            valid = false;
            setError('first_name', 'الحد الأقصي 255 حروف');
        }
        else if (!validateNotDigitSpicalCharacters(user.first_name)){
            valid = false;
            setError('first_name', 'لا يجب ان يحتوي علي رموز'); 
        }

        else {
            setError('first_name');
        }
    }
    //valid user Father Name
    if (!validateRequired(user.second_name)) {
        valid = false;
        setError('second_name', 'رجاء إدخال البيانات');
    } else {
        if (!validateMaxLength(user.second_name, 255)) {
            valid = false;
            setError('second_name', 'الحد الأقصي 255 حروف');
        }
        else if (!validateNotDigitSpicalCharacters(user.second_name)){
            valid = false;
            setError('second_name', 'لا يجب ان يحتوي علي رموز'); 
        }

        else {
            setError('second_name');
        }
    }

    //valid user GrandFather Name
    if (!validateRequired(user.third_name)) {
        valid = false;
        setError('third_name', 'رجاء إدخال البيانات');
    } else {
        if (!validateMaxLength(user.third_name, 255)) {
            valid = false;
            setError('third_name', 'الحد الأقصي 255 حروف');
        }
        else if (!validateNotDigitSpicalCharacters(user.third_name)){
            valid = false;
            setError('third_name', 'لا يجب ان يحتوي علي رموز'); 
        }

        else {
            setError('third_name');
        }
    }
    //valid user Family Name
    if (!validateRequired(user.fourth_name)) {
        valid = false;
        setError('fourth_name', 'رجاء إدخال البيانات');
    } else {
        if (!validateMaxLength(user.fourth_name, 255)) {
            valid = false;
            setError('fourth_name', 'الحد الأقصي 255 حروف');
        }
        else if (!validateNotDigitSpicalCharacters(user.fourth_name)){
            valid = false;
            setError('fourth_name', 'لا يجب ان يحتوي علي رموز'); 
        }

        else {
            setError('fourth_name');
        }
    }

    if (!validateRequired(user.phone_number)) {
        valid = false;
        setError( 'phone_number', 'رجاء إدخال البيانات');
    } else {
        if (!validateLength(user.phone_number, 11)) {
            valid = false;
            setError( 'phone_number', 'رقم التليفون يجب أن يكون 11 رقم');
        } else {
            setError( 'phone_number');
        }
    }
        //validate governate
        if (!validateRequired(user.governorate_id)) {
            valid = false;
            setError( 'governorate_id', 'رجاء إدخال البيانات');
        } else {
            setError( 'governorate_id');
        }
        //validate city
        if (!validateRequired(user.district_id)) {
            valid = false;
            setError( 'district_id', 'رجاء إدخال البيانات');
        } else {
            setError( 'district_id');
        }
        //validate area
        if (!validateRequired(user.village_id)) {
            valid = false;
            setError( 'village_id', 'رجاء إدخال البيانات');
        } else {
            setError( 'village_id');
        }
        //validate street
        if (!validateRequired(user.street_id)) {
            valid = false;
            setError( 'street_id', 'رجاء إدخال البيانات');
        } else {
            setError( 'street_id');
        }

        //validate street other
        if (parseInt(user.street_id) === -1) {
            if (!validateRequired(user.street_other)) {
                valid = false;
                setError( 'street_other', 'رجاء إدخال البيانات');
            } else {
                if (!validateMaxLength(user.street_other, 255)) {
                    valid = false;
                    setError( 'street_other', 'الحد الأقصي 255 حروف');
                }
                
                else if (validateSpicalCharacters(user.street_other) )
                {
                    valid = false;
                    setError( 'street_other', 'لا يجب ان يحتوي علي رموز');
                }
                else {
                    setError( 'street_other');
                }
            }
        }
        //validate building number
        if (!validateRequired(user.building_number)) {
            valid = false;
            setError( 'real_estate_num', 'رجاء إدخال البيانات');
        }  else if (!validateMaxLength(user.building_number, 100)) {
                valid = false;
                setError( 'real_estate_num', 'الحد الأقصي 100 حرف');
         } else {
            setError( 'real_estate_num');
        } 
    return valid;

};
const validateProfileFields = (setError, user, fieldName, value) => {
    let valid = true;
    //valid user First Name
    switch(fieldName) {
        case 'first_name':
            if (!validateRequired(value)) {
                valid = false;
                setError('first_name', 'رجاء إدخال البيانات');
            } else {
                if (!validateMaxLength(value, 255)) {
                    valid = false;
                    setError('first_name', 'الحد الأقصي 255 حروف');
                } else if (!validateNotDigitSpicalCharacters(value)) {
                    valid = false;
                    setError('first_name', 'لا يجب ان يحتوي علي رموز');
                } else {
                    setError('first_name');
                }
            }
            break;
        case 'second_name':
            //valid user Father Name
            if (!validateRequired(value)) {
                valid = false;
                setError('second_name', 'رجاء إدخال البيانات');
            } else {
                if (!validateMaxLength(value, 255)) {
                    valid = false;
                    setError('second_name', 'الحد الأقصي 255 حروف');
                } else if (!validateNotDigitSpicalCharacters(value)) {
                    valid = false;
                    setError('second_name', 'لا يجب ان يحتوي علي رموز');
                } else {
                    setError('second_name');
                }
            }
            break;
        case 'third_name':
            //valid user GrandFather Name
            if (!validateRequired(user.third_name)) {
                valid = false;
                setError('third_name', 'رجاء إدخال البيانات');
            } else {
                if (!validateMaxLength(user.third_name, 255)) {
                    valid = false;
                    setError('third_name', 'الحد الأقصي 255 حروف');
                } else if (!validateNotDigitSpicalCharacters(user.third_name)) {
                    valid = false;
                    setError('third_name', 'لا يجب ان يحتوي علي رموز');
                } else {
                    setError('third_name');
                }
            }
            break;
        case 'fourth_name':
            //valid user Family Name
            if (!validateRequired(user.fourth_name)) {
                valid = false;
                setError('fourth_name', 'رجاء إدخال البيانات');
            } else {
                if (!validateMaxLength(user.fourth_name, 255)) {
                    valid = false;
                    setError('fourth_name', 'الحد الأقصي 255 حروف');
                } else if (!validateNotDigitSpicalCharacters(user.fourth_name)) {
                    valid = false;
                    setError('fourth_name', 'لا يجب ان يحتوي علي رموز');
                } else {
                    setError('fourth_name');
                }
            }
            break;
        case 'phone_number':
            if (!validateRequired(value)) {
                valid = false;
                setError( 'phone_number', 'رجاء إدخال البيانات');
            } else if (!validateLength(value, 11) && user.nationality.key === "EG") {
                    valid = false;
                    setError( 'phone_number', 'رقم التليفون يجب أن يكون 11 رقم');
            } else if (!validateMaxLength(value, 20) && user.nationality.key !== "EG") {
                valid = false;
                setError( 'phone_number', 'رقم التليفون يجب أن يكون أقل من 20 رقم');
            } else {
                    setError( 'phone_number');
            }
            break;
        case 'governorate_id':
            //validate governate
            if (!validateRequired(value)) {
                valid = false;
                setError('governorate_id', 'رجاء إدخال البيانات');
            } else {
                setError('governorate_id');
            }
            break;
        case 'district_id':
            //validate city
            if (!validateRequired(value)) {
                valid = false;
                setError('district_id', 'رجاء إدخال البيانات');
            } else {
                setError('district_id');
            }
            break;
        case 'village_id':
            //validate area
            if (!validateRequired(value)) {
                valid = false;
                setError('village_id', 'رجاء إدخال البيانات');
            } else {
                setError('village_id');
            }
            break;
        case 'street_id':
            //validate street
            if (!validateRequired(value)) {
                valid = false;
                setError('street_id', 'رجاء إدخال البيانات');
            } else {
                setError('street_id');
            }
            break;
        case 'street_other':
            //validate street other
            if (!validateRequired(value)) {
                valid = false;
                setError('street_other', 'رجاء إدخال البيانات');
            } else {
                if (!validateMaxLength(value, 255)) {
                    valid = false;
                    setError('street_other', 'الحد الأقصي 255 حروف');
                } else if (validateSpicalCharacters(value)) {
                    valid = false;
                    setError('street_other', 'لا يجب ان يحتوي علي رموز');
                } else {
                    setError('street_other');
                }
            }
            break;
        case 'building_number':
            //validate building number
            if (!validateRequired(value)) {
                valid = false;
                setError('real_estate_num', 'رجاء إدخال البيانات');
            } else if (!validateMaxLength(value, 100)) {
                    valid = false;
                    setError('real_estate_num', 'الحد الأقصي 100 حرف');
            } else {
                    setError('real_estate_num');
            }
            break;
        default:
            break;
    }
    return valid;

};


export default validateProfile;
export {validateProfileFields}